import React from 'react';
import './styles/Loading.css'

function Loading() {
    return (
        <>
            <div className='d-flex justify-content-center'>
                <div className="loader"></div>
            </div>
            <p
                className="form-check-label align-items-center fw-bold h5 text-center"
                htmlFor="flexCheckDefault">
                Carregando...
            </p>
        </>
    );
}

export default Loading;
